var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveSearch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    width: 23,
    height: 23,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 23,
    height: 23,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAMAAADX9CSSAAAAAXNSR0IB2cksfwAAAYBQTFRF////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////D+WI+wAAAIB0Uk5TCGLN5uPk5eu8NABw//b7/fj3zjPhv2q21nxva4rnzzXvS3mwClbR6EiFsglX6oTHUEBBQySO/uzt7vC6J1XITF78wyYMNkJO8g5jX2RFC3L59ViG+mxUJQ0QL7UUHsK3FiHpSVLxerETvV1N9JYwmMRHN4Kjmtjg29za4osdnZQTMhrzAAABOElEQVR4nIXQ+TcCURTA8aExU7dbMzXJEm1ki5IoRSKU3SB7tsi+r9n/dfNeMw79wPendz73nffOuQxTUaljWbaqFMfrDUBijIgmMwqiyUJSjlaJuk2ottdgbV29keRoaESnizi6PeDFpmZQ8/HYYiDe2gbt2OHXHDp5dEqKd3kggMHuUA8p3EsHVol6H0bc0X6lWHxgECDB4ZDiSRjmzCM0AVOjylNeUaQ+Np4OlUoThkw8Sr0838TfPpmcmtaamZ379nmTKGuJC4uQoO6BJZQ5lmbTZXEZVlQPoH51bZ3k3wii/Ydv5tQvt7Z/+c6u6nup/zy/r+zzpzvgoEDuh+EQj7T9H5/gKZwV3My5fHF5hdc3rluSlLHineHenGceMPsYQ8tT8Zn08iojX4zgG/P+IWB5ls/cF1hcTfnJhMbVAAAAAElFTkSuQmCC"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveSearch2);
export default __webpack_public_path__ + "static/media/saveSearch2.21eba363ab9ea1050a452954a70cad3b.svg";
export { ForwardRef as ReactComponent };